import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { SmsInfo } from '../interface';
import { AppEventJsonDifferenceDto, AppEventModel, EventResourceService } from '../vn-api';

@Injectable({
  providedIn: 'root'
})
export class HxEventService {
  constructor(
    private httpService: HttpClient,
    private eventApi: EventResourceService,
  ) {
  }

  getOrderEventList(orderId: number): Promise<AppEventModel[]> {
    return firstValueFrom(this.eventApi.getByContainer('Order', orderId));
  }

  getInvoiceEventList(orderId: number): Promise<AppEventModel[]> {
    return firstValueFrom(this.eventApi.getByContainer('Invoice', orderId));
  }

  getSmsInfo(eventId: number): Promise<SmsInfo> {
    return firstValueFrom(this.httpService.get<SmsInfo>(`/api/vn/events/${eventId}/sms-info`));
  }

  getDiff(opt: { newEventId: number; oldEventId: number }): Promise<AppEventJsonDifferenceDto> {
    return firstValueFrom(this.eventApi.compareJsonFromEvents(opt));
  }

  getStorageInvoiceEventList(storageInvoiceId: number): Promise<AppEventModel[]> {
    return firstValueFrom(this.eventApi.getByContainer('StorageInvoice', storageInvoiceId));
  }

  getPaymentApprovalEventList(paymentApprovalId: number): Promise<AppEventModel[]> {
    return firstValueFrom(this.eventApi.getByContainer('PaymentApproval', paymentApprovalId));
  }
}
